import React from 'react';
import { FullTable } from 'components';
import { sortListByKey, useModal } from 'utils';
import { ReportsBody, ReportsHead, ReportsNotYet } from './constants';
import { GenerateReport, billingReportEnums } from './core';

export const BillingReports = ({}) => {
    const { open } = useModal();

    const openGenerate = (item) => {
        open(<GenerateReport info={item?.generateInfo} />);
    };

    return (
        <div>
            <FullTable
                head={ReportsHead}
                body={ReportsBody(openGenerate)}
                list={sortListByKey(billingReportEnums, 'name')}
                notYet={ReportsNotYet('Billing')}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
